"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_VERSION = exports.DATA_VERSION = void 0;
exports.DATA_VERSION = '1.0';
exports.EVENT_VERSION = '1.1';
